import VueCookies from "vue-cookies";

const JwtService = {

  token: null,
  payload: {
    roles: [],
    login: "",
    expdate: 0,
    valid: false,
    timeRemaining: 0
  },

  parsePayload(token) {

    if (!token) {
      token = this.getToken();
      this.token = token;
    }

    let payload = {
      jti: "AnonymousAPI",
      roles: [],
      expdate: new Date(),
      valid: false    
    };

    if (token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      payload = JSON.parse(jsonPayload);

      if (payload) {
        payload.roles = payload["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || [];
        payload.login = payload.jti;
        payload.expdate = new Date(payload.exp * 1000);
        payload.valid = new Date(payload.exp * 1000) > new Date();
        payload.timeRemaining = (new Date(payload.exp * 1000) - Math.floor(Date.now() / 1000))
      }
    }

    this.payload = payload;

    return payload;
  },

  getToken() {
    const token = VueCookies.get("token") && VueCookies.get("token") !== '' ? VueCookies.get("token") : null;
    const anontoken = VueCookies.get("anontoken") && VueCookies.get("anontoken") !== '' ? VueCookies.get("anontoken") : null;

    return token || anontoken || "";
  },

  getUser() {
    return this.parsePayload().login;
  } 
}

// monitora o token
setInterval(function () {
  if (!JwtService.payload) {
    JwtService.parsePayload(JwtService.getToken())
  };
  if (JwtService.payload) {
    JwtService.payload.timeRemaining = (new Date(JwtService.payload.exp * 1000) - Math.floor(Date.now() / 1000));
    if (JwtService.payload.timeRemaining > 0 && JwtService.payload.timeRemaining < 30) {
    } else {
      if (JwtService.payload.timeRemaining < 0) {
      }
    }
  }
}, 1000)

export default JwtService;
